<template>
  <div>
    <Schedule :eventId="eventId" :idProfessional="idProfessional" :typeSchedule="typeSchedule"></Schedule>
  </div>
</template>
<script>
import { xray } from "../../../../config/pluginInit";

import Schedule from "../../../../components/schedule/Schedule";

export default {
  name: "ProfessionalContactSchedule",
  components: {
    Schedule,
  },
  data() {
    return {
      eventId: this.$route.query.eventId,
      typeSchedule: "PROFESSIONAL",
      idProfessional: null,
    };
  },
  mounted() {
    xray.index();
    utilsService.auditActivity({ action: "VIEW", module: "PROFESSIONAL_SCHEDULED", info: "" });
  },
  computed: {},
  methods: {},
};
</script>
